/**
 * @author：
 * @update：
 * @description：
 **/
import {messageList,messageRead,messageAllRead} from '../../api/url'
export default {
    data() {
        return {
            activeNames:[],
            listContent:[],
            btnOk:false,
            page:1,
            size:20,
            count:0,
            loading:false,
        };
    },
    // 自定义方法
    methods: {
        messageChange(val) {
            let index = val[val.length-1];
            if(this.listContent[index]!=undefined){
                let readBol = this.listContent[index].haveRead;
                if(readBol==false){
                    this.$ajax.put(messageRead(this.listContent[index].id),{id:this.listContent[index].id}).then(res=>{
                        console.log(res);
                        this.listContent[index].haveRead = true;
                    },err=>{
                        console.log(err);
                        this.$message({
                            showClose:true,
                            message:err.data,
                            type:'error',
                            center:true,
                            duration:3000
                        })
                    })
                }
            }

        },
        showMessage(){
            this.activeNames = [];
            this.btnOk = !this.btnOk;
            this.page = 1;
            // setTimeout(function(){
                this.messageData();
            // }.bind(this),300)
        },
        messageData(bol){
            this.loading=true;
            let data = {
                obj:'ADMINISTRATOR',
                pageNumber:this.page,
                pageSize:this.size,
            };
            if(bol){
                data.haveRead = false
            }
            this.$ajax.get(messageList,data).then(res=>{
                console.log(res);
                this.listContent = res.data.rows;
                this.count = res.data.total;
                for(let i = 0; i < res.data.rows.length; i++){
                    if(res.data.rows[i].haveRead==false){
                        this.$store.commit("modifyIsTopBadge", true);
                        break
                    }
                    if(i+1==res.data.rows.length){
                        this.$store.commit("modifyIsTopBadge", false);
                    }
                }
                this.loading=false;
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
                this.loading=false;
            })
        },
        unread(){
            if(this.btnOk == true) {
                let data = {
                    haveRead : false,
                    obj:'ADMINISTRATOR',
                    pageNumber:this.page,
                    pageSize:this.size,
                };
                // if(this.btnOk){
                //     data.haveRead = false
                // }
                this.$ajax.get(messageList,data).then(res=>{
                    console.log(res);
                    this.listContent = res.data.rows;
                    this.count = res.data.total;
                    for(let i = 0; i < res.data.rows.length; i++){
                        if(res.data.rows[i].haveRead==false){
                            this.$store.commit("modifyIsTopBadge", true);
                            break
                        }
                        if(i+1==res.data.rows.length){
                            this.$store.commit("modifyIsTopBadge", false);
                        }
                    }
                    this.loading=false;
                },err=>{
                    console.log(err);
                    this.$message({
                        showClose:true,
                        message:err.data,
                        type:'error',
                        center:true,
                        duration:3000
                    })
                    this.loading=false;
                })
            }
        },
        currentChange(page){
            this.page = page;
            this.messageData();
        },
        //全部已读
        allRead(){
            this.$ajax.put(messageAllRead).then(res=>{
                console.log(res);
                this.messageData();
            },err=>{
                console.log(err);
                this.$message({
                    showClose:true,
                    message:err.data,
                    type:'error',
                    center:true,
                    duration:3000
                })
            })
        }
    },
    // 数据观察监听
    watch: {
        btnOk(newData,oldData){
            this.page = 1;
            this.messageData(newData)
        }
    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {

    },
    // 组件挂载完成之前
    beforeMount() {
        this.messageData()
    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
